import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { BudgetCategory as BudgetCategoryType, Condition, BudgetLineItem as BudgetLineItemType } from '../types/budget';
import { BudgetLineItem } from './BudgetLineItem';
interface BudgetCategoryProps {
  category: BudgetCategoryType;
  conditions: Condition[];
  onAddCondition: (item: BudgetLineItemType) => void;
  onEditCondition: (condition: Condition) => void;
}
export function BudgetCategory({
  category,
  conditions,
  onAddCondition,
  onEditCondition
}: BudgetCategoryProps) {
  const formatCurrency = (value: number) => new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
  const formatPercent = (value: number) => new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  }).format(value) + '%';
  const categoryConditions = conditions.filter(c => c.categoryId === category.id);
  const hasConditions = categoryConditions.length > 0;
  return <>
      {/* Line Items */}
      {category.lineItems.map(item => <BudgetLineItem key={item.id} item={item} condition={conditions.find(c => c.lineItemId === item.id)} onAddCondition={() => onAddCondition(item)} onEditCondition={() => {
      const cond = conditions.find(c => c.lineItemId === item.id);
      if (cond) onEditCondition(cond);
    }} data-id="element-1" />)}

      {/* Category Total Row */}
      <tr className="bg-tertiary/20 font-bold text-primary" data-id="element-2">
        <td className="border border-gray-300 px-2 py-1 text-xs font-body uppercase flex items-center justify-between" data-id="element-3">
          <span data-id="element-4">{category.name}</span>
          {hasConditions && <span className="flex items-center gap-1 px-1.5 py-0.5 rounded bg-accent-1 text-primary text-[10px] font-medium border border-accent-1/50" data-id="element-5">
              <AlertTriangleIcon className="w-3 h-3" data-id="element-6" />
              {categoryConditions.length} Mod
              {categoryConditions.length > 1 ? 's' : ''}
            </span>}
        </td>

        <td className="border border-gray-300 px-2 py-1 text-right text-xs font-body tabular-nums" data-id="element-7">
          {formatPercent(category.totalPercent)}
        </td>

        <td className="border border-gray-300 px-2 py-1 text-right text-xs font-body tabular-nums" data-id="element-8">
          -
        </td>

        <td className="border border-gray-300 px-2 py-1 text-right text-xs font-body tabular-nums" data-id="element-9">
          {formatCurrency(category.totalBudget)}
        </td>

        <td className="border border-gray-300 px-2 py-1 text-center text-xs font-body bg-gray-50/50" data-id="element-10">
          {/* Reallocation Request column */}
        </td>
      </tr>

      {/* Spacer row to match Excel visual grouping slightly, or just let them stack. Excel stacks them tightly. */}
      <tr data-id="element-11">
        <td colSpan={4} className="h-1 bg-white border-x border-gray-300" data-id="element-12"></td>
      </tr>
    </>;
}